import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import { ToastProvider } from '../../components/Toast';
import { usePermissions } from '../../hooks/usePermissions';
import HR from '../HR';

// Jumps to Settings → HR & Payroll (Work Schedule / Leave Types / Holidays
// List cards) in the main app shell. HR opens in its own tab/window
// (StandaloneShell), so this is a real navigation, not an in-page state
// change — Dashboard.js picks up `navOpenPage` on mount and opens straight
// into Settings, scrolled to the HR & Payroll section.
function openHrSettings() {
  localStorage.setItem('navOpenPage', 'settings');
  localStorage.setItem('navGroup', 'hr');
  window.location.href = '/dashboard';
}

export default function HRPage() {
  const token = localStorage.getItem('token');
  const { isAdmin } = usePermissions();

  return (
    <StandaloneShell
      title="HR"
      headerActions={isAdmin ? (
        <button
          onClick={openHrSettings}
          title="HR & Payroll Settings"
          style={{
            display: 'flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 9,
            border: '1px solid transparent', background: 'linear-gradient(135deg,#0f1f45,#1a3a6b)',
            color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer',
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          HR &amp; Payroll Settings
        </button>
      ) : null}
    >
      {({ darkMode, T }) => (
        <PermissionGate module="hr" moduleName="HR">
          <ToastProvider>
            <HR token={token} darkMode={darkMode} T={T} />
          </ToastProvider>
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
